<template>
   <div :style="{'height':height,'width':'100%'}" id="container" tabindex="0">
        <el-amap class="amap-box"
				:center="center"
				expandZoomRange="true"
				:zoom="zoom">
					<el-amap-marker :position="center" ></el-amap-marker>
        </el-amap>
    </div>
</template>
<script>
import { AMapManager } from "vue-amap";
// let amapManager = new AMapManager();
export default({
	data(){
		return{
			zoom:'16',
			center:[106.565395,29.675663],
			markers:[106.565395,29.675663],
			
		}
	},
	props:['height'],
	methods:{
		
	}
})

</script>
<style scoped>

.search-box {
    position: absolute;
    top: 25px;
    left: 20px;
}
</style>
